module.exports = __webpack_public_path__ + "img/header.5d722778.jpg";